/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { SiegeLieuSuiviGridDto } from './SiegeLieuSuiviGridDto';
import {
    SiegeLieuSuiviGridDtoFromJSON,
    SiegeLieuSuiviGridDtoFromJSONTyped,
    SiegeLieuSuiviGridDtoToJSON,
} from './SiegeLieuSuiviGridDto';

/**
 * 
 * @export
 * @interface SiegeLieuSuiviGridDtoPaginatedResults
 */
export interface SiegeLieuSuiviGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof SiegeLieuSuiviGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<SiegeLieuSuiviGridDto>}
     * @memberof SiegeLieuSuiviGridDtoPaginatedResults
     */
    results?: Array<SiegeLieuSuiviGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof SiegeLieuSuiviGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the SiegeLieuSuiviGridDtoPaginatedResults interface.
 */
export function instanceOfSiegeLieuSuiviGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SiegeLieuSuiviGridDtoPaginatedResultsFromJSON(json: any): SiegeLieuSuiviGridDtoPaginatedResults {
    return SiegeLieuSuiviGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function SiegeLieuSuiviGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiegeLieuSuiviGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(SiegeLieuSuiviGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function SiegeLieuSuiviGridDtoPaginatedResultsToJSON(value?: SiegeLieuSuiviGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(SiegeLieuSuiviGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

